import types from './types';
import { diagramsSel } from './index';
import store from 'src/store';

import modelService from 'src/services/model/modelService';
import productService from 'src/services/products/ProductService';
import DiagramModel from 'src/model/diagram.model';
import ProductModel from 'src/model/product.model';
import listService from 'src/services/lists/ListsService';
import { featuredProductsSel, commonPartsSel } from './selectors';

import { analyticsActions } from 'src/analytics/store';
import { analyticsListNames } from 'src/analytics/constant';

const getModel = (
  modelId: string,
  activeAccount: string,
  manufacturer: string
) => {
  const product = new ProductModel();
  const newProducts: ProductModel[] = [];
  let diagrams: DiagramModel[] = [];
  return (dispatch: any) => {
    dispatch(getModelIsPending(true));
    modelService
      .getModelData(modelId, activeAccount, manufacturer)
      .then((model: any) => {
        const { rpmodel } = model;
        dispatch(setTextFilter(''));
        dispatch(setId(rpmodel.id));
        dispatch(setModelId(rpmodel.modelId));
        modelService
          .addDiagramOwnerToProducts(rpmodel.diagrams)
          .then((newDiagrams: DiagramModel[]) => {
            diagrams = newDiagrams;
            dispatch(setDiagrams(newDiagrams));
          });
        dispatch(setModelNumber(rpmodel.modelNumber));
        dispatch(setModelName(rpmodel.modelName));
        dispatch(setManufacturer(rpmodel.manufacturer));
        dispatch(setBrandName(rpmodel.brandName));
        dispatch(setApplianceType(rpmodel.applianceType));
        dispatch(setProductionNumber(rpmodel.productionNumber));
        rpmodel.featuredProducts.forEach((element: string) => {
          newProducts.push({
            ...product,
            productNumber: element,
            featured: true,
            productDetailsState: 'pending'
          });
        });
        dispatch(setFeaturedProducts(newProducts));
        modelService
          .addDiagramOwnerToProducts(rpmodel.commonParts)
          .then((newDiagrams: DiagramModel[]) => {
            diagrams = newDiagrams;
            dispatch(setCommonParts(newDiagrams));
          });
        dispatch(getModelIsPending(false));
        dispatch(analyticsActions.selectedModelInformation(rpmodel));
      })
      .catch(error => {
        console.error(error);
        dispatch(getModelIsPending(false));
      });
  };
};

const getModelIsPending = (isPending: boolean) => {
  return { type: types.GET_MODEL_IS_PENDING, payload: isPending };
};

const setId = (id: number) => {
  return {
    type: types.SET_ID,
    payload: id ? id : 0
  };
};

const setModelId = (modelId: number) => {
  return {
    type: types.SET_MODEL_ID,
    payload: modelId ? modelId : 0
  };
};

const setDiagrams = (diagrams: DiagramModel[]) => {
  return {
    type: types.SET_DIAGRAMS,
    payload: diagrams ? diagrams : []
  };
};

const setCommonParts = (commonParts: DiagramModel[]) => {
  return {
    type: types.SET_COMMON_PARTS,
    payload: commonParts ? commonParts : []
  };
};

const setFeaturedProducts = (featuredProducts: ProductModel[]) => {
  return {
    type: types.SET_FEATURED_PRODUCTS,
    payload: featuredProducts ? featuredProducts : []
  };
};

const setModelNumber = (modelNumber: number) => {
  return {
    type: types.SET_MODEL_NUMBER,
    payload: modelNumber ? modelNumber : 0
  };
};

const setModelName = (modelName: string) => {
  return {
    type: types.SET_MODEL_NAME,
    payload: modelName ? modelName : ''
  };
};

const setManufacturer = (manufacturer: string) => {
  return {
    type: types.SET_MANUFACTURER,
    payload: manufacturer ? manufacturer : ''
  };
};

const setBrandName = (brandName: string) => {
  return {
    type: types.SET_BRAND_NAME,
    payload: brandName ? brandName : ''
  };
};

const setApplianceType = (applianceType: string) => {
  return {
    type: types.SET_APPLIANCE_TYPE,
    payload: applianceType ? applianceType : ''
  };
};

const setProductionNumber = (productionNumber: string) => {
  return {
    type: types.SET_PRODUCTION_NUMBER,
    payload: productionNumber = productionNumber ? productionNumber : ''
  };
};

const setTextFilter = (textFilter: string) => {
  return { type: types.SET_TEXT_FILTER, payload: textFilter };
};

const setActiveDiagram = (diagramId: number) => {
  return { type: types.SET_ACTIVE_DIAGRAM, payload: diagramId };
};

const toggleFavorites = (
  name: string,
  mfc: string,
  ownerDiagram: number,
  favorite: boolean,
  favoriteId: number,
  featured: boolean
) => {
  return (dispatch: any) => {
    const storeData: any = store.getState();
    const newDiagrams: DiagramModel[] = [...diagramsSel(storeData)];
    const spi: number[] = [];
    let sdi: number = 0;
    // sdi = Selected diagram index
    sdi = newDiagrams.findIndex((diagram: DiagramModel) => {
      return diagram.diagramId === ownerDiagram;
    });
    if (sdi !== -1) {
      // spi = Slelected product indexes
      newDiagrams[sdi].products.forEach((item, index) => {
        if (item.productNumber === name) {
          spi.push(index);
        }
      });
      if (spi.length > 0) {
        if (favorite) {
          listService.deleteItem(favoriteId).then((res: any) => {
            spi.forEach(partIndex => {
              newDiagrams[sdi].products[partIndex] = {
                ...newDiagrams[sdi].products[partIndex],
                idFavoriteItem: null,
                favorite: false
              };
            });
            dispatch(setDiagrams(newDiagrams));
          });
        } else {
          listService.addItem('favorites', name, mfc).then((res: any) => {
            spi.forEach(partIndex => {
              newDiagrams[sdi].products[partIndex] = {
                ...newDiagrams[sdi].products[partIndex],
                idFavoriteItem: res.listItemNumber,
                favorite: true
              };
            });
            dispatch(setDiagrams(newDiagrams));
          });
        }
      }
    }
    if (featured) {
      const newFeaturedProducts: ProductModel[] = [
        ...featuredProductsSel(storeData)
      ];
      newFeaturedProducts.findIndex((item, index) => {
        if (item.productNumber === name) {
          spi.push(index);
        }
      });

      if (spi.length > 0) {
        if (favorite) {
          listService.deleteItem(favoriteId).then((res: any) => {
            spi.forEach(partIndex => {
              newFeaturedProducts[partIndex] = {
                ...newDiagrams[sdi].products[partIndex],
                idFavoriteItem: null,
                favorite: false
              };
            });
            dispatch(setFeaturedProducts(newFeaturedProducts));
          });
        } else {
          listService.addItem('favorites', name, mfc).then((res: any) => {
            spi.forEach(partIndex => {
              newFeaturedProducts[partIndex] = {
                ...newDiagrams[sdi].products[partIndex],
                idFavoriteItem: res.listItemNumber,
                favorite: true
              };
            });
            dispatch(setFeaturedProducts(newFeaturedProducts));
          });
        }
      }
    }
  };
};

const updateCommonProducts = (
  products: Array<{
    productId: string;
    manufacturerCode: string;
    ownerDiagram: number;
  }>
) => {
  return (dispatch: any) => {
    const storeData: any = store.getState();
    const newDiagrams: DiagramModel[] = [...commonPartsSel(storeData)];
    let spi: number = 0;
    let spisum: number = 0;
    let sdi: number = 0;
    const productsArray: Array<{
      productNumber: string;
      manufacturerCode: string;
    }> = [];
    products.forEach(product => {
      productsArray.push({
        productNumber: product.productId,
        manufacturerCode: product.manufacturerCode
      });
    });
    productService.getProductsSearch(productsArray).then(response => {
      response.forEach((product, i) => {
        // sdi = Selected diagram index
        sdi = newDiagrams.findIndex((diagram: DiagramModel) => {
          return diagram.diagramId === products[i].ownerDiagram;
        });
        if (sdi !== -1) {
          // spi = Selected product index
          spi = newDiagrams[sdi].products.findIndex(
            item => item.productNumber === products[i].productId
          );
          spisum = spi;
          while (spi !== -1) {
            newDiagrams[sdi].products[spisum] = {
              ...newDiagrams[sdi].products[spisum],
              ...product,
              // description: newDiagrams[sdi].products[spisum].description,
              partSeries: newDiagrams[sdi].products[spisum].partSeries,
              score: newDiagrams[sdi].products[spisum].score
            };
            newDiagrams[sdi].products[spisum].productDetailsState = 'loaded';
            newDiagrams[sdi].products[spisum].isAvailable = product.available;
            spi = newDiagrams[sdi].products
              .slice(spisum + 1)
              .findIndex(item => item.productNumber === products[i].productId);
            spisum += spi + 1;
          }
        }
      });
      dispatch(setCommonParts(newDiagrams));
      dispatch(
        analyticsActions.sendModelProductImpression({
          diagrams: newDiagrams,
          list: analyticsListNames.COMMON_LIST_BY_MODEL,
          model: storeData.model.modelNumber
        })
      );
    });
  };
};

const updateDiagramProducts = (
  products: Array<{
    productId: string;
    manufacturerCode: string;
    ownerDiagram: number;
  }>
) => {
  return (dispatch: any) => {
    const storeData: any = store.getState();
    const newDiagrams: DiagramModel[] = [...diagramsSel(storeData)];
    let spi: number = 0;
    let spisum: number = 0;
    let sdi: number = 0;
    const productsArray: Array<{
      productNumber: string;
      manufacturerCode: string;
    }> = [];
    products.forEach(product => {
      productsArray.push({
        productNumber: product.productId,
        manufacturerCode: product.manufacturerCode
      });
    });
    productService.getProductsSearch(productsArray).then(response => {
      response.forEach((product, i) => {
        // sdi = Selected diagram index
        sdi = newDiagrams.findIndex((diagram: DiagramModel) => {
          return diagram.diagramId === products[i].ownerDiagram;
        });
        if (sdi !== -1) {
          // spi = Selected product index
          spi = newDiagrams[sdi].products.findIndex(
            item => item.productNumber === products[i].productId
          );
          spisum = spi;
          while (spi !== -1) {
            newDiagrams[sdi].products[spisum] = {
              ...newDiagrams[sdi].products[spisum],
              ...product,
              // description: newDiagrams[sdi].products[spisum].description,
              partSeries: newDiagrams[sdi].products[spisum].partSeries
            };
            newDiagrams[sdi].products[spisum].productDetailsState = 'loaded';
            newDiagrams[sdi].products[spisum].isAvailable = product.available;
            spi = newDiagrams[sdi].products
              .slice(spisum + 1)
              .findIndex(item => item.productNumber === products[i].productId);
            spisum += spi + 1;
          }
        }
      });
      dispatch(setDiagrams(newDiagrams));
      dispatch(
        analyticsActions.storeModelDiagramProductData({
          allModelProducts: newDiagrams
        })
      );
    });
  };
};

const updateDiagramProduct = (
  productId: string,
  manufacturerCode: string,
  ownerDiagram: number
) => {
  return (dispatch: any) => {
    const storeData: any = store.getState();
    const newDiagrams: DiagramModel[] = [...diagramsSel(storeData)];
    let spi: number = 0;
    let sdi: number = 0;
    // sdi = Selected diagram index
    sdi = newDiagrams.findIndex((diagram: DiagramModel) => {
      return diagram.diagramId === ownerDiagram;
    });
    if (sdi !== -1) {
      // spi = Slelected product index
      spi = newDiagrams[sdi].products.findIndex(
        item => item.productNumber === productId
      );
      if (
        spi !== -1 &&
        newDiagrams[sdi].products[spi].productDetailsState === 'pending'
      ) {
        // newDiagrams[sdi].products[spi].productDetailsState = "loading";
        // dispatch(setDiagrams(newDiagrams));
        productService
          .getProductsSearch([{ productNumber: productId, manufacturerCode }])
          .then(response => {
            newDiagrams[sdi].products[spi] = {
              ...newDiagrams[sdi].products[spi],
              ...response[0],
              // description: newDiagrams[sdi].products[spi].description,
              partSeries: newDiagrams[sdi].products[spi].partSeries
            };
            newDiagrams[sdi].products[spi].productDetailsState = 'loaded';
            newDiagrams[sdi].products[spi].isAvailable = true;
            dispatch(setDiagrams(newDiagrams));
          })
          .catch((error: any) => {
            if (error.message === '404 null') {
              newDiagrams[sdi].products[spi].isAvailable = false;
              newDiagrams[sdi].products[spi].productDetailsState = 'none';
              dispatch(setDiagrams(newDiagrams));
            } else {
              newDiagrams[sdi].products[spi].productDetailsState = 'none';
              dispatch(setDiagrams(newDiagrams));
            }
          });
      }
    }
  };
};

const updateFeaturedProduct = (productId: string, manufacturerCode: string) => {
  return (dispatch: any) => {
    const storeData: any = store.getState();
    const newFeaturedProducts: ProductModel[] = [
      ...featuredProductsSel(storeData)
    ];
    let spi: number = 0;
    // spi = Selected product index
    spi = newFeaturedProducts.findIndex((product: ProductModel) => {
      return product.productNumber === productId;
    });
    if (
      spi !== -1 &&
      newFeaturedProducts[spi].productDetailsState === 'pending'
    ) {
      // newFeaturedProducts[spi].productDetailsState = "loading";
      // dispatch(setFeaturedProducts(newFeaturedProducts));
      productService
        .getProductsSearch([{ productNumber: productId, manufacturerCode }])
        .then(response => {
          newFeaturedProducts[spi] = {
            ...newFeaturedProducts[spi],
            ...response[0],
            // description: newFeaturedProducts[spi].description,
            partSeries: newFeaturedProducts[spi].partSeries
          };
          newFeaturedProducts[spi].productDetailsState = 'loaded';
          newFeaturedProducts[spi].isAvailable = true;
          dispatch(setFeaturedProducts(newFeaturedProducts));
        })
        .catch((error: any) => {
          if (error.message === '404 null') {
            newFeaturedProducts[spi].isAvailable = false;
            newFeaturedProducts[spi].productDetailsState = 'none';
            dispatch(setFeaturedProducts(newFeaturedProducts));
          } else {
            newFeaturedProducts[spi].productDetailsState = 'none';
            dispatch(setFeaturedProducts(newFeaturedProducts));
          }
        });
    }
  };
};

const getActivePart = (part: ProductModel) => {
  return (dispatch: any) => {
    if (part !== null) {
      const mfc = part.manufacturerCode ? part.manufacturerCode : '';
      productService
        .getProductDetails(part.productNumber, mfc)
        .then(response => {
          part.productDetails = response;
          dispatch(setActivePart(part));
        })
        .catch((error: any) => {
          part.productDetails = null;
          dispatch(setActivePart(part));
        });
    } else {
      dispatch(setActivePart(part));
    }
  };
};

const setActivePart = (part: ProductModel | null) => {
  return { type: types.SET_ACTIVE_PART, payload: part };
};

export default {
  setId,
  setModelId,
  getModel,
  setModelNumber,
  setModelName,
  setManufacturer,
  setBrandName,
  setApplianceType,
  setProductionNumber,
  getModelIsPending,
  setTextFilter,
  setActiveDiagram,
  updateDiagramProduct,
  setActivePart,
  getActivePart,
  toggleFavorites,
  updateFeaturedProduct,
  updateDiagramProducts,
  updateCommonProducts
};
